import QuadrantImage from'./QuadrantImage'

export default class Pusher extends QuadrantImage {

	constructor(gl, gor) {
		super(gl, gor, 'pusher');
	}

	defaultOpts() {
		const opts = super.defaultOpts();
		opts.scale = 3.5;
		opts.split = [[1,1],[1,1],[1,1],[1,1]];
		return opts;
	}

}
